import styled from 'styled-components';
import { ReactComponent as CheckOrange } from '../../../../../assets/icons/checkOrange.svg';
import { ReactComponent as ChevronDown } from '../../../../../assets/icons/chevronDown.svg';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const SelectContainer = styled.div`
  position: relative;
  width: ${({ device }) => (device === 'mobile' ? '100%' : 'auto')};
  max-width: ${({ device }) => (device === 'mobile' ? 'none' : '400px')};
  font-family: sans-serif;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  height: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const SelectInput = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 8px;
  border: 1px solid ${({ open }) => (open ? getColor('primary') : select('black'))};
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'desktop') return '274px';
    return '236px';
  }};
  border-radius: 8px;
  height: 48px;
  cursor: pointer;
  position: relative;
  color: ${select('neutralDarkGrayII')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const LabelSelected = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${({ device }) => {
    if (device === 'mobile') return '290px';
    if (device === 'desktop') return '238px';
    return '200px';
  }};
  display: inline-block;

  @media (min-width: 390px) and (max-width: 450px) {
    width: 320px;
  }
`;

const ChevronIcon = styled(ChevronDown)`
  position: absolute;
  right: 12px;
  transform: rotateX(${({ open }) => (open ? '180deg' : '0deg')});
  transition: transform 0.1s ease;
  pointer-events: none;
`;

const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${select('white')};
  border-radius: 8px;
  border: 1px solid ${select('neutralDarkGray')};
  margin-top: 8px;
  z-index: 100;
  padding: 8px 1px;
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'desktop') return '274px';
    return '236px';
  }};
  max-height: 400px;
  overflow-x: auto;
  white-space: break-spaces;
  overflow-y: none;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);

  /* Estilos del scroll */
  ::-webkit-scrollbar {
    width: 4px;
    height: 20px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
    width: 8px;
    border-radius: 3px;
    padding: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${select('midDarkGrayAux')};
    border-radius: 3px;
    background-clip: content-box;
  }
`;

const Option = styled.li`
  list-style: none;
  padding: 8px 16px;
  background: ${select('white')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  height: fit-content;
  &:hover {
    background: ${select('neutralGray')};
  }
`;

const LabelContainer = styled.div`
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
`;

const CheckIcon = styled(CheckOrange)`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  fill: ${getColor('primary')};
  path {
    fill: ${getColor('primary')};
  }
`;

export { SelectContainer, Label, SelectInput, ChevronIcon, Dropdown, Option, LabelContainer, CheckIcon, LabelSelected };
